export default __webpack_public_path__ + "MBD_Teilnahmebedingungen_Stand_09-2025.pdf";